import {onBeforeUnmount, ref} from 'vue';

/**
 * Whether the reader asked the OS for reduced motion (prefers-reduced-motion: reduce), live. False on the server and
 * where matchMedia is missing, so a decorative animation only ever plays once the browser has said it is welcome.
 * Grant 2026-11-02: Tappy's avatar sits still for these readers (the CSS media query is the belt, this the braces,
 * so the Thinking face is never left half-drawn by `animation: none`).
 */
export function useReducedMotion() {
  const reduced = ref(false);
  if (import.meta.client && typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    try {
      const query = window.matchMedia('(prefers-reduced-motion: reduce)');
      reduced.value = query.matches;
      const onChange = (event) => { reduced.value = event.matches; };
      query.addEventListener?.('change', onChange);
      onBeforeUnmount(() => query.removeEventListener?.('change', onChange));
    } catch (err) {
      reduced.value = false;
    }
  }
  return reduced;
}
